export interface ITableContactData {
  count: number;
  pages: number;
  contacts: TableContact[];
}

export interface IContactHiringOnValue {
  _id: string;
  name: string;
}

export interface IContactHiringOn {
  name: string;
  section?: string;
  _id: string;
  value: IContactHiringOnValue[];
}

export interface IAssessment {
  likes: number;
  dislikes: number;
}

export interface ITableContactCompanyName {
  name: string;
}

export interface ITableContact {
  id: number;
  _id: number;
  role_type: string;
  first_name: string;
  last_name: string;
  published_vacancies: number;
  photo: string;
  assessment: IAssessment;
  hiring_on: IContactHiringOn[];
  employer_company: ITableContactCompanyName;
}

export class TableContact {
  id: number;
  _id: number;
  role_type: string;
  first_name: string;
  last_name: string;
  full_name: string;
  published_vacancies: number;
  photo: string;
  assessment: IAssessment;
  hiring_on: IContactHiringOn[];
  employer_company: ITableContactCompanyName;

  constructor( data: ITableContact ) {
    this.id = data.id;
    this._id = data._id;
    this.role_type = data.role_type;
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.full_name = `${this.first_name} ${this.last_name}`;
    this.published_vacancies = data.published_vacancies;
    this.photo = data.photo;
    if (data.assessment) {
      this.assessment = {
        likes: data.assessment.likes || 0,
        dislikes: data.assessment.dislikes || 0
      };
    } else {
      this.assessment = {
        likes: 0,
        dislikes: 0
      };
    }
    this.hiring_on = data.hiring_on;
    this.employer_company = data.employer_company;
  }
}



// WEBPACK FOOTER //
// ./app/core/services/employer/table-contact.ts